module.exports = __webpack_public_path__ + "static/img/IMG_20160617_014708.845c96a6.jpg";